import { styled } from "@mui/material/styles";
import { ArrowDownIcon } from "@UI";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { interruptionKey } from "../utils/cardInterruption";
import { answersOf, answerText, questionsOf } from "../utils/choiceModel";
import { SettledLine } from "./HookCard";
const TONES = {
    waiting: "wait",
    answered: "ok",
    dismissed: "neutral",
    skipped: "neutral",
    expired: "muted"
};
const Status = styled("span")({
    "&[data-tone=wait]": {
        display: "inline-flex",
        alignItems: "center",
        gap: "var(--j-sp-1)",
        color: "var(--j-ink)",
        fontWeight: 500
    }
});
const Answer = styled("span")({
    color: "var(--j-ink)",
    fontWeight: 500
});
const Pairs = styled("dl")({
    margin: "var(--j-sp-0-5) 0 0",
    display: "grid",
    gridTemplateColumns: "minmax(0, auto) minmax(0, 1fr)",
    gap: "var(--j-sp-1) var(--j-sp-3)",
    "& dt": {
        color: "var(--j-ink-3)",
        overflowWrap: "anywhere"
    },
    "& dd": {
        margin: 0,
        color: "var(--j-ink)",
        fontWeight: 500,
        overflowWrap: "anywhere"
    }
});
function lineStateOf(selection, interrupted) {
    if (selection) return selection.cancelled ? "dismissed" : "answered";
    if (interrupted === "skipped") return "skipped";
    return interrupted ? "expired" : "waiting";
}
export function choiceTitle(request, batchTitle) {
    const questions = questionsOf(request);
    return questions.length === 1 ? questions[0].question : request.message || batchTitle;
}
export function QuestionLine({ request, selection, interrupted }) {
    const { t } = useTranslation();
    const questions = questionsOf(request);
    const state = lineStateOf(selection, interrupted);
    const sawWaiting = useRef(false);
    useEffect(()=>{
        if (state === "waiting") sawWaiting.current = true;
    }, [
        state
    ]);
    const answers = answersOf(questions, selection);
    const title = choiceTitle(request, t("chat.ask.batchTitle"));
    return /*#__PURE__*/ React.createElement(SettledLine, {
        key: state,
        tone: TONES[state],
        role: state === "waiting" ? "status" : undefined,
        focusIfLost: state !== "waiting" && sawWaiting.current
    }, /*#__PURE__*/ React.createElement("span", null, title), state === "waiting" && /*#__PURE__*/ React.createElement(Status, {
        "data-tone": "wait"
    }, t("chat.ask.waitingBelow", {
        count: questions.length
    }), /*#__PURE__*/ React.createElement(ArrowDownIcon, {
        size: 14
    })), state === "answered" && questions.length === 1 && /*#__PURE__*/ React.createElement(Answer, null, answerText(questions[0], answers.get(questions[0].id))), state === "answered" && questions.length > 1 && /*#__PURE__*/ React.createElement(Pairs, null, questions.map((question, index)=>/*#__PURE__*/ React.createElement(React.Fragment, {
            key: question.id
        }, /*#__PURE__*/ React.createElement("dt", null, question.header ?? t("chat.ask.questionNumber", {
            number: index + 1
        })), /*#__PURE__*/ React.createElement("dd", null, answerText(question, answers.get(question.id)) ?? "–")))), state === "dismissed" && /*#__PURE__*/ React.createElement(Status, null, t("chat.ask.dismissed")), (state === "skipped" || state === "expired") && /*#__PURE__*/ React.createElement(Status, null, t(interruptionKey(interrupted))));
}
